// --------------------------------------------------------------
// Created On: 2026-07-01
// Author: Dimitra Weinstein
//
// Last Modified: 2026-07-17
// Modified By: Dimitra Weinstein
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import React from "react";
import styles from "./AiAgentButton.module.scss";

// Button component for toggling the AI Agent Chat Window.
export default function AiAgentButton(props: Props): Component {
  return (
    <div className={`${styles.container} mx-auto d-flex justify-content-center align-items-center`}>
      {props.location === "NAVBAR" && (
        <button
          className={`${styles.btn} btn btn-primary text-center`}
          type="button"
          onClick={() => props.onClick()}
          aria-haspopup="true"
          data-test="ai-agent-button-navbar"
        >
          <img src="/images/ai_microchip.png" alt="AI Agent" className={`mr-2 ${styles.icon}`} />
        </button>
      )}
      {props.location === "NAVIGATION_DRAWER" && (
        <button
          className="btn btn-primary mx-3 my-4 px-auto w-50 text-center"
          type="button"
          onClick={() => props.onClick()}
          aria-haspopup="true"
          data-test="ai-agent-button-navigation-drawer"
        >
          <img src="/images/ai_microchip.png" alt="AI Agent" className={`mx-1 pb-1 ${styles.icon}`} />
          <span className="fs-5 px-auto">Agent</span>
        </button>
      )}
    </div>
  );
}

interface Props {
  location: "NAVBAR" | "NAVIGATION_DRAWER";
  onClick: () => void;
}
